module.exports = {
	"header": {
		"company": "VMware",
		"title-cloud": "VMware HCX",
		"title-onprem": "VMware HCX",
		"title": "VMware HCX",
		"vcloud": "VMware vCloud",
		"air": "Air",
		"services": "Services",
		"dashboard": "Dashboard",
		"designer": "Data Center Designer",
		"inventory": "Inventory",
		"administration": "Administration",
		"settings": "Settings",
		"about": "About",
		"help": "Help",
		"logout": "Log out",
		"copyright": "Copyright",
		"years": "2019",
		"aboutText": "VMware, Inc. All rights reserved. This product is protected by copyright and intellectual property laws in the United States and other countries as well as by international treaties. VMware products are covered by one or more patents listed at ",
		"tradeMarkText": "VMware is a registered trademark or trademark of VMware Inc. in the United States and other jurisdictions. All other marks and names mentioned herein may be trademarks of their respective companies.",
		"termsText": "Terms of Service",
		"legal": "Legal Disclaimers",
		"support": "Support Center",
		"loadError": "Failed to load some of the resources. Turn off ad blockers, if any, installed on your browser and relaunch the application.",
		"interconnectAlert": "Interconnect configuration is a prerequisite for adding a HCX Interconnect between two sites. HCX Interconnect activates Mobility, Network Extension and other hybrid services.",
		"interconnectAlertAction": "Configure Interconnect",
		"interconnectDeprecation": "Please note Interconnect Configuration is being deprecated.",
		"computProfileAlert": "Multisite configuration is a prerequisite for adding a HCX Interconnect between two sites. HCX Interconnect activates Mobility, Network Extension and other hybrid services.",
		"computeProfileAlertAction": "Configure Compute Profile",
		"interconnect": "Multi-Site Service Mesh",
		"fleet": "HCX Components (Deprecated)",
		"interconnect2": "Interconnect",
		"infrastructure": "Infrastructure",
		"sitePairing": "Site Pairing",
		"underlay": "Transport Analytics"
	},
	"dashboard": {
		"welcome": {
			"head": "Hybrid Connectivity",
			"mesg": "Connect your remote datacenter using VMware HCX.",
			"button": "DOWNLOAD VMWARE HCX CLIENT"
		},
		"title": "Dashboard",
		"cloudOverview": "Cloud Overview",
		"resourceUsage": "Resource Usage",
		"warningPre": "You are running out of",
		"vmRetrieveError": "Failed to retrieve VMs",
		"vcRetrieveError": "Failed to retrieve VCs",
		"viewAll": "VIEW ALL",
		"back": "BACK",
		"vdcPolicyEnabled": "Virtual Datacenters have policy activated",
		"vAppsProtected": "vApps Protected",
		"tb": "TB",
		"gb": "GB",
		"unlimited": "Unlimited",
		"storageConsumed": "Storage Consumed",
		"topDC": "Top 5 Datacenters by Storage consumed",
		"delvApps": "Deleted vApps",
		"storageConsumedBy": "Storage Consumed by Deleted vApps",
		"storageTrend": "Storage Trend Graph",
		"DPS": "Data Protection Service",
		"activityLog": "Activity Log",
		"ipsConsumed": "You have consumed {{ percentageUsed }}% of {{ networkName }} IPs"
	},
	"services": {
		"disasterRecovery": "Disaster Recovery",
		"networkExtension": "Network Extension",
		"networkExtension2": "Network Extension",
		"migration": "Migration"
	},
	"auth": {
		"rememberMe": "Remember Me",
		"login": " LOG IN",
		"invalidUsername": "Invalid username or password, or too many active sessions",
		"logoutProgress": "Logout in Progress",
		"logoutComplete": "You have successfully logged out of VMware HCX",
		"vcCredentials": "Use vSphere domain credentials to login",
		"unauthorized": "Access is denied",
		"govCloudDisclaimer": {
			"title": "U.S. Government (USG) Consent to Monitoring Notice",
			"body": "You are accessing a U.S. Government (USG) information system (IS) that is provided for USG-authorized use only. By using this IS (which includes any device attached to this IS), you consent to the following conditions:<br>The USG routinely intercepts and monitors communications on this IS for purposes including, but not limited to, penetration testing, COMSEC monitoring, network operations and defense, personnel misconduct (PM), law enforcement (LE), and counterintelligence (CI) investigations.<br>At any time, the USG may inspect and seize data stored on this IS.<br>Communications using, or data stored on, this IS are not private, are subject to routine monitoring, interception, and search, and may be disclosed or used for any USG-authorized purpose.<br>This IS includes security measures (e.g., authentication and access controls) to protect USG interests--not for your personal benefit or    privacy.<br>Notwithstanding the above, using this IS does not constitute consent to PM, LE or CI investigative searching or monitoring of the content of privileged communications, or work product, related to personal representation or services by attorneys, psychotherapists, or clergy, and their assistants.<br><br>Such communications and work product are private and confidential. See User Agreement for details.",
			"agree": "I Agree",
			"exit": "Exit"
		},
		"forbiddenRequest": "You don't have permissions to access this HCX system or too many active sessions. Try again after sometime.",
		"serverUnavailable": "The server is temporarily unable to service your request due to maintenance downtime or capacity problems. Try again later.",
		"unknownError": "Something went wrong. Try again later."
	},
	"common": {
		"buttons": {
			"ok": "OK",
			"submit": "Submit",
			"save": "Save",
			"cancel": "Cancel",
			"apply": "Apply",
			"remove": "Remove",
			"refresh": "Refresh",
			"action": "Actions",
			"run": "Run",
			"delete": "Delete"
		},
		"statuses": {
			"failed": "FAILED",
			"success": "SUCCESS",
			"running": "RUNNING",
			"partial": "PARTIAL",
			"partialSuccess": "PARTIAL SUCCESS",
			"poweredOff": "POWERED OFF",
			"poweredOn": "POWERED ON"
		},
		"manageInVcloud": "Manage In vCloud Director",
		"loading": "Loading..."
	},
	"leftNav": {
		"label": "CRUD Sample"
	},
	"crudModule": {
		"actionButtons": {
			"createGateway": "Create Gateway",
			"editGateway": "Edit Gateway",
			"deleteGateway": "Delete Gateway"
		},
		"gatewayGrid": {
			"name": "Name",
			"vdcName": "Org VDC",
			"gatewayIP": "Gateway IP",
			"configuration": "Configuration",
			"ha": "High Availability",
			"externalNetworks": "External Networks",
			"status": "Status",
			"renderers": {
				"failureText": "Failed",
				"failureToolTip": "Gateway creation failed",
				"creationText": "Created",
				"creationToolTip": "Gateway creation succeeded",
				"inProgressText": "In Progress",
				"inProgressToolTip": "Gateway creation is in progress"
			}
		},
		"gatewayPopup": {
			"createMode": {
				"title": "Create Gateway",
				"saveButtonLabel": "Add"
			},
			"editMode": {
				"title": "Edit Gateway",
				"saveButtonLabel": "Save"
			},
			"formElementLabels": {
				"name": "Name",
				"namePlaceHolder": "Gateway Name",
				"description": "Description",
				"vdc": "Select VDC",
				"selectVdc": "Select Organization VDC",
				"externalNetwork": "Select External Network",
				"selectExternalNetwork": "Select External Network",
				"ipCount": "IP Count"
			},
			"errorMessages": {
				"emptyName": "Please provide the gateway name",
				"emptyVdc": "Please select VDC",
				"emptyNetwork": "Please select network",
				"emptyIP": "Please provide the number of IP required",
				"minIP": "Please provide at least 1 IP",
				"maxIP": "No Of IPs are more than available IP"
			}
		}
	},
	"dpsModule": {
		"noServices": {
			"msg": "No Service available"
		},
		"notHealthy": {
			"msg": "Data Protection Services have not been configured for your environment!"
		},
		"placeholders": {
			"openDeletedVapps": "Open Deleted vApps",
			"openVapps": "Open vApps",
			"openActivityLog": "Open Activity Log"
		},
		"license": {
			"noLicense": "Data Protection Service is not configured. Please contact the administrator for more details."
		},
		"buttons": {
			"submit": "Submit",
			"cancel": "Cancel",
			"apply": "Apply"
		},
		"deletedVapps": {
			"popupHeader": "Deleted vApps",
			"grid": {
				"header": {
					"vapp": "vApp",
					"restorePoints": "Restore Points",
					"storage": "Storage"
				},
				"message": {
					"emptyTable": "No deleted vApps are available",
					"infoEmpty": "No deleted vApps are available"
				}
			}
		},
		"vapps": {
			"popupHeader": "vApps",
			"grid": {
				"header": {
					"vapp": "vApp",
					"restorePoints": "Restore Points",
					"storage": "Storage",
					"backupPolicy": "Backup Policy",
					"lastBackup": "Last Successful Backup",
					"activityLog": "Activity Log"
				},
				"actionButtons": {
					"applyPolicy": "Apply Policy",
					"editPolicy": "Edit Policy",
					"removePolicy": "Remove Policy",
					"runAdhocBackup": "Run Adhoc Backup",
					"configureEmail": "Configure Email Address"
				},
				"message": {
					"emptyTable": "No vApps are available",
					"infoEmpty": "No vApps are available"
				}
			}
		},
		"activityLog": {
			"popupHeader": "Activity Log",
			"grid": {
				"header": {
					"entityName": "Entity Name",
					"entityType": "Entity Type",
					"operation": "Operation",
					"status": "Status",
					"startTime": "Start Time",
					"endTime": "End Time",
					"user": "User"
				},
				"message": {
					"emptyTable": "No activity logs are available",
					"infoEmpty": "No activity logs are available"
				}
			}
		},
		"applyPolicy": {
			"popupHeaderApplyPolicy": "Apply Backup Policy for vApp",
			"popupHeaderEditPolicy": "Edit Backup Policy for vApp",
			"popupHeaderApplyPolicyVDC": "Apply Backup Policy for VDC",
			"popupHeaderEditPolicyVDC": "Edit Backup Policy for VDC",
			"retentionPolicy": "Retention Policy",
			"retentionBackup": "Retain backups for",
			"retentionPeriod": "Retention Period",
			"warningVapp": "Any snapshots taken for this vApp will not be backed up.",
			"warningVDC": "Any snapshots taken for the vApp(s) of this VDC will not be backed up.",
			"days": "days",
			"validation": {
				"emptyRetentionPeriod": "Please enter a positive number (min: 2 and max: 365) days as Retention Period"
			}
		},
		"deletePolicy": {
			"vapp": {
				"popupHeader": "Remove Backup Policy from vApp",
				"description1": "Remove backup policy for vApp",
				"description2": "Scheduled back up operations on this vApp will be suspended. The existing restore points will be retained as per the last applied policy."
			},
			"vdc": {
				"popupHeader": "Remove Backup Policy from VDC",
				"description1": "Remove backup policy for vDC",
				"description2": "Scheduled back up operations on this VDC will be suspended. The existing restore points will be retained as per the last applied policy."
			}
		},
		"adhocBackup": {
			"popupHeader": "Run Adhoc Backup on vApp",
			"description": "Set a retention period for this particular backup.",
			"retentionPeriod": "Retention Period",
			"warning": "Any snapshots taken for this vApp will not be backed up.",
			"days": "days",
			"validation": {
				"emptyRetentionPeriod": "Please enter a positive number (min: 2 and max: 365) days as Retention Period"
			},
			"button": {
				"run": "Run"
			}
		},
		"configureEmail": {
			"popupHeaderVapp": "Configure Email Address for vApp",
			"popupHeaderVDC": "Configure Email Address for VDC",
			"description": "Please enter one or more email address (comma separated) to receive notifications in case of failed backup(s) and restore(s).",
			"email": "Email Address(es)",
			"tooltip": "Please enter valid email addresses separated by commas.",
			"validation": {
				"invalidEmailList": "Invalid Email list. Please enter valid email addresses separated by commas."
			}
		},
		"restorePoints": {
			"popupHeaderVapp": "Restore Points for vApp",
			"grid": {
				"header": {
					"creationDate": "Creation Date",
					"expiryDate": "Expiry Date",
					"name": "Name",
					"virtualMachines": "Virtual Machines",
					"status": "Status",
					"size": "Size",
					"storageConsumed": "Storage Consumed"
				},
				"actionButtons": {
					"inPlaceRestore": "In Place Restore",
					"outOfPlaceRestore": "Out of Place Restore",
					"deleteAllRestorePoints": "Delete All Restore Points",
					"refreshRestorePoints": "Refresh Restore Points"
				},
				"message": {
					"emptyTable": "No Restore Points are available",
					"infoEmpty": "No Restore Points are available"
				}
			}
		},
		"deleteRestore": {
			"popupHeader": "Delete All Restore Points",
			"description": "You are requesting to delete all restore points of vApp - {{vAppName}} on vDC - {{vdcName}}."
		},
		"refreshRestore": {
			"popupHeader": "Refresh Restore Points",
			"description": "This will refresh all the restore point of the vApp - {{vAppName}} on vDC - {{vdcName}} and the storage consumption. The operation might take sometime to complete. Do you want to refresh?"
		},
		"inPlaceRestore": {
			"popupHeader": "In Place Restore",
			"description": "You are requesting to restore vApp - {{vAppName}} on vDC - {{vdcName}}.",
			"restore": "Restore",
			"entireVapp": "Entire vApp",
			"specificVms": "Select specific Virtual Machines to restore",
			"vms": "Virtual Machines",
			"warning1": "The restore operation will not affect the VM metadata, network configuration, user access permissions and other configuration information. Once the restore process is complete, kindly change these setting manually.",
			"warning2": "Please make sure the VM(s) in the vApp are in powered off state.",
			"warning3": "Any snapshots taken for this vApp will not be restored."
		},
		"outOfPlaceRestore": {
			"popupHeader": "Out of Place Restore",
			"description": "You are requesting to restore vApp - {{vAppName}} on vDC - {{vdcName}}. Choose your target vDC and name your vApp.",
			"nameOfVapp": "Name of vAPP",
			"targetVDC": "Target vDC",
			"storageProfile": "Storage Profile",
			"message": {
				"emptyCombo": "Please select an item in the list",
				"emptyName": "Please enter the name of the vApp"
			},
			"restore": "Restore",
			"entireVapp": "Entire vApp",
			"specificVms": "Select specific Virtual Machines to restore",
			"vms": "Virtual Machines",
			"warning1": "The restore operation will not affect the VM metadata, network configuration, user access permissions and other configuration information. Once the restore process is complete, kindly change these setting manually.",
			"warning2": "Please make sure the VM(s) in the vApp are in powered off state.",
			"warning3": "Any snapshots taken for this vApp will not be restored."
		},
		"updateRestore": {
			"popupHeader": "Change Expiry Date",
			"expiryDate": "Expiry Date",
			"oldDateWarning": "The selected expiry date is not valid, please select a date/time which is greater than current date/time.",
			"infoDateUpdate": "Please click on the date to update it.",
			"description": "You are requesting to change expiry date of a restore point of vApp: \"{{vAppName}}\" on vDC: \"{{vdcName}}\"."
		},
		"scheduleSelector": {
			"frequency": "Frequency",
			"schedule": "Schedule",
			"timezone": "Time Zone",
			"days": "days",
			"hours": "hours",
			"repeatEveryDay": "Repeat every day",
			"repeatEveryWeek": "Repeat every week",
			"repeatEveryMonth": "Repeat every month",
			"repeatEveryYearsInMonth": "Repeat every year in the month(s)",
			"daysOfMonth": "Day(s) of Month",
			"daysCommaSeparated": "Day(s) comma separated",
			"at": "at",
			"frequecyCombo": {
				"daily": "Daily",
				"weekly": "Weekly",
				"monthly": "Monthly",
				"yearly": "Yearly"
			},
			"messages": {
				"invalidMonthDate": "At-least one of the 'month and date combination' is invalid. Please correct it.",
				"warning31stDay": "Please note that the months 'February', 'April', 'June', 'September' and 'November' are not having 31st, so the scheduler will not run on those days.",
				"warning30thDay": "Please note that 'February' does not have 30th, so the scheduler will not run on that month.",
				"warning29thDay": "Please note that 'February' does not have 29th except on leap years, so the scheduler will not run on 29th of 'February' if it's a non-leap year."
			}
		},
		"dashboard": {
			"date": "Date",
			"dialogs": {
				"viewAllDeletedVapps": "Deleted vApps"
			}
		},
		"cards": {
			"vdc": {
				"title": "Data Protection",
				"details": {
					"statusEnabled": "Backup Policy is activated",
					"statusDisabled": "Backup Policy is not activated",
					"name": "Name",
					"backupPolicy": "Backup Policy",
					"storageConsumed": "Storage Consumed",
					"protectionCoverage": "Protection Coverage",
					"enablePolicy": "ACTIVATE POLICY",
					"removePolicy": "Remove Backup Policy",
					"replicationPolicy": "Replication Policy",
					"replicationSite": "Replication Site"
				},
				"actionDropdown": {
					"addPolicy": "Add Backup Policy",
					"editPolicy": "Edit Backup Policy",
					"openVapps": "vApps",
					"openDeletedVapps": "Deleted vApps",
					"openActivityLog": "Activity Log",
					"setReplicationSite": "Set Replication Site",
					"configureReplicationPolicy": "Configure Replication Policy",
					"editReplicationPolicy": "Edit Replication Policy",
					"removeReplicationPolicy": "Remove Replication Policy"
				},
				"dialogTitles": {
					"applyPolicyVDC": "Apply Backup Policy for VDC",
					"vapps": "vApps for VDC",
					"deletedVapps": "Deleted vApps for VDC",
					"activityLog": "Activity Logs for VDC",
					"addPolicyVDC": "Add Backup Policy for VDC",
					"editPolicyVDC": "Edit Backup Policy for VDC",
					"removePolicyVDC": "Remove Backup Policy for VDC",
					"setReplicationSite": "Set Replication Site for VDC",
					"configureReplicationPolicy": "Configure Replication Policy for VDC",
					"editReplicationPolicy": "Edit Replication Policy for VDC",
					"removeReplicationPolicy": "Remove Replication Policy for VDC"
				}
			},
			"vapp": {
				"title": "Data Protection",
				"details": {
					"statusEnabled": "Backup Policy is activated",
					"statusDisabled": "Backup Policy is not activated",
					"name": "Name",
					"backupPolicy": "Backup Policy",
					"storageConsumed": "Storage Consumed",
					"restorePointCount": "Restore Points",
					"enablePolicy": "ACTIVATE POLICY",
					"removePolicy": "Remove Backup Policy",
					"replicationPolicy": "Replication Policy"
				},
				"actionDropdown": {
					"addPolicy": "Add Backup Policy",
					"editPolicy": "Edit Backup Policy",
					"openVapps": "vApps",
					"openDeletedVapps": "Deleted vApps",
					"openActivityLog": "Activity Log",
					"applyReplicationPolicy": "Apply Replication Policy",
					"editReplicationPolicy": "Edit Replication Policy",
					"removeReplicationPolicy": "Remove Replication Policy",
					"replicateNow": "Replicate Now"
				},
				"dialogTitles": {
					"activityLog": "Activity Logs for vApp",
					"addPolicyVapp": "Add Backup Policy for vApp",
					"editPolicyVapp": "Edit Backup Policy for vApp",
					"removePolicyVapp": "Remove Backup Policy for vApp",
					"applyReplicationPolicy": "Apply Replication Policy for vApp",
					"editReplicationPolicy": "Edit Replication Policy for vApp",
					"removeReplicationPolicy": "Remove Replication Policy for vApp",
					"replicateNow": "Replicate vApp"
				}
			}
		},
		"replicatedVdc": {
			"license": {
				"noLicense": "Replication Service is not configured. Please contact the administrator for more details."
			},
			"vdcList": {
				"title": "Replicated Virtual Datacenter",
				"storageConsumed": "Storage Consumed",
				"vm": "VM",
				"placeholder": "No Replicated Virtual Datacenter Found",
				"of": "of",
				"modalDialog": {
					"setReplicationSite": {
						"fields": {
							"destinationSite": {
								"title": "Destination Site",
								"placeHolder": "Choose Destination Site",
								"emptyMsg": "Destination Site is required",
								"errorMsg": "Destination Site is invalid"
							}
						}
					},
					"removeReplicationPolicy": {
						"delWarningMsg1": "Remove replication policy for VDC",
						"delWarningMsg2": "Scheduled replication operations on this VDC will be suspended. The existing replicated restore points will be retained as per the last applied policy."
					}
				}
			},
			"vappList": {
				"vdc": {
					"title": "Virtual Datacenter",
					"storageConsumed": "Storage Consumed"
				},
				"title": "The replicated vApps of this Virtual Datacenter are listed below",
				"vapp": "vApp",
				"restorePoint": "Restore Points",
				"storage": "Storage",
				"vm": "VM",
				"status": "Status",
				"placeholder": "No Replicated vApps Found",
				"of": "of",
				"modalDialog": {
					"replicateNow": {
						"confirmMsg": "Please click on RUN button to proceed"
					},
					"removeReplicationPolicy": {
						"delWarningMsg1": "Remove replication policy for vApp",
						"delWarningMsg2": "Scheduled replication operations on this vApp will be suspended. The existing replicated restore points will be retained as per the last applied policy."
					}
				},
				"vms": {
					"popupHeader": "VMs for vApp: ",
					"popupHeaderRestorePoint": "VMs for Restore Point: ",
					"grid": {
						"header": {
							"vm": "VM",
							"status": "Status",
							"creationDate": "Creation Date",
							"expiryDate": "Expiry Date",
							"size": "Size",
							"storageConsumed": "Storage Consumed"
						},
						"message": {
							"emptyTable": "No Vms are available",
							"infoEmpty": "No Vms are available",
							"success": "SUCCESS",
							"failure": "FAILURE",
							"partialSuccess": "PARTIAL SUCCESS",
							"footerMsg": "{{num1}} - {{num2}} of {{num3}} restore points"
						}
					}
				},
				"restorePoints": {
					"popupHeader": "Restore Points for vApp: ",
					"grid": {
						"header": {
							"creationDate": "Creation Date",
							"expiryDate": "Expiry Date",
							"name": "Name",
							"virtualMachines": "Virtual Machines",
							"status": "Status",
							"size": "Size",
							"storageConsumed": "Storage Consumed"
						},
						"actionButtons": {
							"outOfPlaceRestore": "Out of Place Restore"
						},
						"message": {
							"emptyTable": "No Restore Points are available",
							"infoEmpty": "No Restore Points are available",
							"singleSelection": "Multiple restore points cannot be selected.",
							"success": "SUCCESS",
							"failure": "FAILURE",
							"partialSuccess": "PARTIAL SUCCESS",
							"footerMsg": "{{num1}} - {{num2}} of {{num3}} restore points"
						}
					}
				}
			}
		}
	},
	"computeModule": {
		"dashboard": {
			"title": "Compute",
			"dashboard": {
				"title": "Dashboard",
				"organization": "ORGANIZATIONS",
				"vdc": "VIRTUAL DATACENTERS",
				"vm": "VIRTUAL MACHINES",
				"poweredOn": "POWERED ON",
				"poweredOff": "POWERED OFF",
				"cpu": "CPU",
				"memory": "Memory",
				"storage": "Storage",
				"used": "USED",
				"allocated": "ALLOCATED",
				"ips": "Public IPs",
				"directIps": "Direct Connect IPs",
				"vcenters": "VCENTERS"
			},
			"vcenter": {
				"grid": {
					"title": "vCenter",
					"emptyTable": "No vCenters are available",
					"nsxVersion": "NSX Version",
					"vcenterVersion": "vCenter Version",
					"nsxhost": "NSX"
				}
			},
			"activityLog": {
				"title": "Activity Logs"
			}
		},
		"org": {
			"actionDropdown": {
				"addOrganization": "Add Organization",
				"editOrganization": "Edit Organization",
				"deleteOrganization": "Delete Organization",
				"addVdc": "Create Org VDC"
			},
			"modalDialog": {
				"addOrganization": {
					"title": "Add Organization",
					"fields": {
						"orgName": {
							"title": "Organization Name",
							"placeHolder": "Enter Organization Name",
							"emptyMsg": "Organization Name is required",
							"errorMsg": "Organization Name is invalid",
							"charLimitExceededMsg": "Organization Name should not exceed 128 characters",
							"specialCharsMsg": "Allowed special characters for Organization Name are : ! $ ( ) _ ' , ."
						},
						"defaultOrgUrl": {
							"title": "Default Organization URL"
						},
						"orgFullName": {
							"title": "Organization Full Name",
							"placeHolder": "Enter Organization Full Name",
							"emptyMsg": "Organization Full Name is required",
							"errorMsg": "Organization Full Name is invalid",
							"charLimitExceededMsg": "Organization Full Name should not exceed 128 characters",
							"specialCharsMsg": "Allowed special characters for Organization Full Name are : ! $ ( ) _ ' , ."
						},
						"orgDescription": {
							"title": "Description",
							"placeHolder": "Enter Description",
							"charLimitExceededOrgDesc": "Organization Description should not exceed 256 characters"
						},
						"orgUserName": {
							"title": "User Name",
							"placeHolder": "Enter User Name",
							"emptyMsg": "User Name is required",
							"errorMsg": "User Name is invalid"
						},
						"orgPwd": {
							"title": "Password",
							"placeHolder": "Enter Password",
							"emptyMsg": "Password is required",
							"errorMsg": "Password is invalid"
						},
						"orgConfirmPwd": {
							"title": "Confirm Password",
							"placeHolder": "Enter Confirm Password",
							"emptyMsg": "Confirm Password is required",
							"errorMsg": "Confirm Password is invalid"
						}
					}
				},
				"editOrganization": {
					"title": "Edit Organization",
					"fields": {
						"orgName": {
							"title": "Organization Name",
							"placeHolder": "Enter Organization Name",
							"emptyMsg": "Organization Name is required",
							"errorMsg": "Organization Name is invalid"
						},
						"orgFullName": {
							"title": "Organization Full Name",
							"placeHolder": "Enter Organization Full Name",
							"emptyMsg": "Organization Full Name is required",
							"errorMsg": "Organization Full is invalid"
						},
						"orgDescription": {
							"title": "Description",
							"placeHolder": "Enter Description"
						}
					}
				},
				"deleteOrganization": {
					"title": "Delete Organization",
					"delWarningMsgPre": "You are requesting to permanently delete organization - ",
					"delWarningMsgPost": ". This operation cannot be undone.",
					"delNotAllowedMsgPre": "This organization - ",
					"delNotAllowedMsgPost": " contains Virtual Datacenters. Delete all Virtual Datacenters before you attempt to delete this organization."
				}
			},
			"details": {
				"ownedBy": "Owned by",
				"created": "created"
			}
		},
		"messages": {
			"deletedEntity": "The entity is no longer in the system."
		},
		"vdc": {
			"actionDropdown": {
				"addVdc": "Add VirtualDatacenter",
				"editVdc": "Edit VirtualDatacenter"
			},
			"modalDialog": {
				"addVdc": {
					"title": "Add VDC"
				},
				"editVdc": {
					"title": "Edit VDC"
				},
				"editSP": {
					"title": "Edit Storage Policies"
				},
				"deleteVdc": {
					"title": "Delete VDC",
					"delWarningMsgPre": "You are requesting to permanently delete Organization VDC - ",
					"delWarningMsgPost": ". This operation cannot be undone.",
					"delDisableMsgPre": "This Organization VDC - ",
					"delDisableMsgPost": "contains vApps. Delete all vApps before you attempt to delete this Organization VDC."
				}
			},
			"details": {
				"vdcDetails": "VDC Details",
				"statusEnabled": "Activated",
				"statusDisabled": "Deactivated",
				"description": "Description",
				"allocationModel": "Allocation Model",
				"sddcPool": "SDDC Pool",
				"cpuUsed": "CPU Used",
				"memoryUsed": "Memory Used",
				"storageUsed": "Storage Used",
				"cpuAllocated": "CPU Allocated",
				"memoryAllocated": "Memory Allocated",
				"services": {
					"title": "Services",
					"dr": {
						"title": "Disaster Recovery",
						"details": {
							"statusEnabled": "Disaster Recovery is activated",
							"statusDisabled": "Disaster Recovery is deactivated",
							"enableRecovery": "ENABLE RECOVERY",
							"removeRecovery": "REMOVE RECOVERY"
						},
						"actionDropdown": {
							"addRecovery": "Add Recovery",
							"editRecovery": "Edit Recovery"
						}
					}
				},
				"storageProfiles": "Storage Profiles",
				"storageProfileGridFooter": "{{num1}} - {{num2}} of {{num3}} storage profiles"
			}
		},
		"vm": {
			"ip": "Host IP",
			"details": "VM Details",
			"vmdetails": "VM Details",
			"computerName": "Computer Name",
			"hostName": "VM IP Address",
			"vAppId": "vApp ID",
			"vimId": "VIM ID",
			"moref": "Mo-Ref",
			"schemaversion": "Schema Version",
			"numberOfCpus": "Number of CPUs",
			"memoryMB": "Memory MB",
			"vimserver": "VIM SERVER",
			"guestOs": "Guest OS",
			"vdc": "VDC",
			"isVAppTemplate": "Is VApp Template",
			"name": "VM Name",
			"vAppName": "vApp Name",
			"vapp": "VAPP",
			"vdcId": "VDC ID",
			"objectId": "Object ID",
			"status": "Status",
			"cpus": "CPUs",
			"owner": "Owner",
			"vnic": "VNIC",
			"vnics": {
				"objectId": "Object ID",
				"macAddress": "MAC Address"
			},
			"modalDialog": {
				"addVm": {
					"title": "Add VM"
				},
				"editVm": {
					"title": "Edit VM"
				},
				"deleteVm": {
					"title": "Delete VM"
				}
			},
			"actionDropdown": {
				"addVm": "Add VM",
				"editVm": "Edit VM"
			}
		},
		"vapp": {
			"details": "vApp Details",
			"owner": "Owner",
			"name": "Name",
			"schemaversion": "Schema Version",
			"vdcId": "VDC ID",
			"objectId": "Object ID",
			"creationDate": "Created On",
			"modalDialog": {
				"addVapp": {
					"title": "Add vApp"
				},
				"editVapp": {
					"title": "Edit vApp"
				},
				"deleteVapp": {
					"title": "Delete vApp"
				}
			}
		},
		"vappGrid": {
			"vcdName": "VCD Name",
			"vdcid": "VDC ID",
			"objectid": "Object ID"
		}
	},
	"createOrgVdc": {
		"grid": {
			"header": {
				"name": "Name",
				"cpu": "CPU",
				"memory": "Memory",
				"storage": "Storage",
				"iopsEnabled": "IOPS Activated",
				"default": "Default",
				"ghz": "GHz",
				"mhz": "MHz",
				"gb": "GB",
				"mb": "MB"
			}
		},
		"allocModel": {
			"PAYASYOUGO": "Pay As You Go",
			"RESERVATIONPOOL": "Reservation Pool",
			"ALLOCATIONPOOL": "Allocation Pool"
		},
		"wizard": {
			"oneDefaultSize": "Select only one Default Size",
			"allocModel": "Allocation Model",
			"allocPool": "Allocation Pool",
			"cpuQuota": "CPU Quota (GHz)",
			"memoryQuota": "Memory Quota (GB)",
			"storageQuota": "Storage Quota (GB)",
			"cpuResourcesGuaranteed": "CPU resources guaranteed (%)",
			"memoryReserved": "Memory Reserved",
			"memoryResourcesGuaranteed": "Memory resources guaranteed (%)",
			"org": "Organization",
			"selectOrg": "Select Organization",
			"name": "Name",
			"desc": "Description",
			"orgVDC": "Org VDC",
			"orgVDCName": "Org VDC Name",
			"sddcPool": "SDDC Pool",
			"memory": "Memory",
			"cpu": "CPU",
			"defaultSizes": "Default Sizes",
			"oneSDDCPool": "Select only one SDDC Pool",
			"defaultIOPS": "Default IOPS",
			"IOPSQuota": "IOPS Quota",
			"setDefault": "Set Default",
			"cpuReserved": "CPU Reserved",
			"of": "of",
			"positiveNo": "Enter a Positive number",
			"decimalCheck": "Positive number with maximum two decimal places is allowed",
			"missingOrgVdcName": "Specify name of the Organization VDC",
			"charLimitExceededOrgVDC": "Organization VDC Name should not exceed 128 characters",
			"charLimitExceededOrgVDCDesc": "Organization VDC Description should not exceed 256 characters",
			"yes": "Yes",
			"no": "No",
			"storageProfiles": "Storage Profiles",
			"cpuGuaranteeToolTip": "Provide CPU resources guaranteed [ 0 - 100 ]",
			"memoryGuaranteeToolTip": "Provide Memory resources guaranteed [ 20 - 100 ]",
			"storageReserved": "Storage Reserved",
			"selectDefaultSizes": "Select Default Sizes",
			"noDefaultStorageProfile": "The default storage policy for the specified VDC cannot be deactivated. Select a new default storage policy first.",
			"storagePositiveNo": "Enter a positive number (min: 1 and max: {{maxStorageLimit}})",
			"cpuQuotaMin": "Enter a positive number (min: 0.26 GHz)",
			"memoryQuotaMin": "Enter a positive number (min: 1 GB)"
		}
	},
	"orgNetwork": {
		"managein": "MANAGE IN VCLOUD DIRECTOR",
		"routed": "Routed",
		"isolated": "Isolated",
		"actions": "Actions",
		"gatewayip": "Gateway IP",
		"type": "Type",
		"organizationNetworks": "Organization Networks",
		"organizationNetwork": "Organization Network"
	},
	"drModule": {
		"title": "Disaster Recovery",
		"overviewTab": {
			"title": "Overview",
			"placeholder": "OVERVIEW TAB CONTENT TODO"
		},
		"replicationsTab": {
			"title": "Replications",
			"placeholder": "REPLICATIONS TAB CONTENT TODO"
		}
	},
	"vcDpsModule": {
		"placeholders": {
			"resourcePools": "Resource Pools",
			"virtualMachines": "Virtual Machines",
			"loading": "Loading",
			"days": "days",
			"defaultDetailsPage": ""
		},
		"deletedVms": {
			"startPageMessage": "Please select a vCenter to view Deleted VMs belonging to it.",
			"vcenterHeader": "Deleted VMs for "
		},
		"title": {
			"dataProtection": "Data Protection",
			"dashboard": "Dashboard",
			"manage": "Manage",
			"deletedvms": "Deleted VMs"
		},
		"buttons": {
			"submit": "Submit",
			"cancel": "Cancel",
			"apply": "Apply",
			"actions": "Actions",
			"ok": "OK",
			"run": "Run",
			"refresh": "Refresh",
			"delete": "Delete",
			"deleteAll": "Delete All"
		},
		"dashboard": {
			"policyEnabled": "Policy Activated",
			"policyNotEnabled": "Policy Not Activated",
			"storageConsumed": "Storage Consumed",
			"storageFree": "Storage Free",
			"notEnoughPrivilegeMessage": "You do not have enough access privileges to use Data Protection Service."
		},
		"vcenter": {
			"modal": {
				"header": {
					"configureEmail": "Configure Email Address"
				},
				"actionButtons": {
					"configureEmail": "Configure Email Address"
				}
			}
		},
		"storageConsumed": {
			"resourcePool": "ResourcePool",
			"cluster": "Cluster",
			"storageConsumed": "Storage Consumed",
			"totalStorageConsumed": "Total Storage Consumed",
			"storageDetails": "Storage Consumption Details"
		},
		"resourcePool": {
			"popupHeader": "Resource Pool",
			"modal": {
				"actionButtons": {
					"addPolicy": "Add Policy",
					"editPolicy": "Edit Policy",
					"removePolicy": "Remove Policy",
					"configureEmail": "Configure Email Address"
				}
			},
			"backupPolicy": "Backup Policy",
			"retention": "Retention",
			"storageConsumed": "Storage Consumed"
		},
		"virtualMachine": {
			"popupHeader": "Virtual Machine",
			"modal": {
				"actionButtons": {
					"addPolicy": "Add Policy",
					"editPolicy": "Edit Policy",
					"removePolicy": "Remove Policy",
					"adhocBackup": "Run Adhoc Backup",
					"restore": "Restore",
					"configureEmail": "Configure Email Address"
				}
			},
			"backupPolicy": "Backup Policy",
			"retention": "Retention",
			"storageConsumed": "Storage Consumed",
			"lastSuccessfulBackup": "Last Successful Backup",
			"restorePoints": "Restore Points"
		},
		"applyPolicy": {
			"popupHeaderApplyPolicy": "Apply Policy for VM: ",
			"popupHeaderEditPolicy": "Edit Policy for VM: ",
			"popupHeaderApplyPolicyResourcePool": "Apply Policy for Resource Pool: ",
			"popupHeaderEditPolicyResourcePool": "Edit Policy for Resource Pool: ",
			"retentionPeriod": "Retention Period",
			"retentionPolicy": "Retention Policy",
			"retentionBackup": "Retain backups for",
			"days": "days",
			"validation": {
				"emptyRetentionPeriod": "Please enter a positive number (min: 2 and max: 365) days as Retention Period"
			}
		},
		"deletePolicy": {
			"vm": {
				"popupHeader": "Remove Policy for Virtual Machine",
				"description1": "Remove backup policy for VM: ",
				"description2": "Scheduled back up operations on this Virtual Machine will be suspended. The existing restore points will be retained as per the last applied policy."
			},
			"rp": {
				"popupHeader": "Remove Policy for Resource Pool",
				"description1": "Remove backup policy for Resource Pool: ",
				"description2": "Scheduled back up operations on this Resource Pool will be suspended. The existing restore points will be retained as per the last applied policy."
			}
		},
		"adhocBackup": {
			"popupHeader": "Run Adhoc Backup on VM: ",
			"description": "Set a retention period for this particular backup.",
			"retentionPeriod": "Retention Period",
			"days": "days",
			"validation": {
				"emptyRetentionPeriod": "Please enter a positive number (min: 2 and max: 365) days as Retention Period"
			},
			"button": {
				"run": "Run"
			}
		},
		"configureEmail": {
			"popupHeaderResourcePool": "Configure Email Address for Resource Pool: {{rpName}}",
			"popupHeaderVirtualMachine": "Configure Email Address for Virtual Machine: {{vmName}}",
			"description": "Please enter one or more email address (comma separated) to receive notifications in case of failed backup(s) and restore(s).",
			"email": "Email Address(es)",
			"tooltip": "Please enter valid email addresses separated by commas.",
			"validation": {
				"invalidEmailList": "Invalid Email list. Please enter valid email addresses separated by commas."
			}
		},
		"restorePoints": {
			"popupHeader": "Restore Points for VM: ",
			"grid": {
				"header": {
					"creationDate": "Creation Date",
					"expiryDate": "Expiry Date",
					"name": "Name",
					"virtualMachines": "Virtual Machines",
					"status": "Status",
					"size": "Size",
					"storageConsumed": "Storage Consumed"
				},
				"actionButtons": {
					"inPlaceRestore": "In Place Restore",
					"outOfPlaceRestore": "Out of Place Restore",
					"deleteAllRestorePoints": "Delete All Restore Points",
					"refreshRestorePoints": "Refresh Restore Points"
				},
				"message": {
					"emptyTable": "No Restore Points are available",
					"infoEmpty": "No Restore Points are available",
					"singleSelection": "Multiple restore points cannot be selected.",
					"success": "SUCCESS",
					"failure": "FAILURE",
					"partialSuccess": "PARTIAL SUCCESS",
					"footerMsg": "{{num1}} - {{num2}} of {{num3}} restore points"
				}
			}
		},
		"deleteRestore": {
			"popupHeader": "Delete All Restore Points",
			"description": "You are requesting to delete all restore points of VM - {{vmName}} on VC - {{vcHost}}."
		},
		"refreshRestore": {
			"popupHeader": "Refresh Restore Points",
			"description": "This will refresh all the restore point of the VM - {{vmName}} on VC - {{vcHost}} and the storage consumption. The operation might take sometime to complete. Do you want to refresh?"
		},
		"inPlaceRestore": {
			"popupHeader": "In Place Restore",
			"description": "You are requesting to restore VM - {{vmName}} on VC - {{vcHost}}.",
			"restore": "Restore",
			"warning1": "The restore operation will not affect the VM metadata, network configuration, user access permissions and other configuration information. Once the restore process is complete, kindly change these setting manually.",
			"warning2": "Please make sure the VM is in powered off state."
		},
		"outOfPlaceRestore": {
			"popupHeader": "Out of Place Restore",
			"name": "Name",
			"step1": "Select a name and folder",
			"step2": "Select a compute resource",
			"step3": "Select a storage",
			"datastore": "Select the datastore",
			"vmFolder": "Select a datacenter or VM folder to create the new virtual machine in",
			"vmComputeResource": "Select a cluster, host, or resource pool to run this virtual machine",
			"message": {
				"emptyCombo": "Please select an item in the list",
				"emptyName": "Enter a valid name for this virtual machine",
				"invalidLocation": "Enter a valid location for this virtual machine",
				"invalidComputeResource": "Specify a valid Cluster, Host, or Resource Pool in which to run this machine",
				"errorValidating": "Error validating compute resource!",
				"errorOutOfPlaceRestore": "Out of place restore request failed!",
				"emptyDatastore": "Select a datastore"
			},
			"restore": "Restore",
			"warning1": "The restore operation will not affect the VM metadata, network configuration, user access permissions and other configuration information. Once the restore process is complete, kindly change these setting manually.",
			"warning2": "Please make sure the VM is in powered off state."
		}
	},
	"activityLog": {
		"header": "Activity Log",
		"username": "User",
		"jobType": "Job Type",
		"operationType": "Operation Type",
		"entityName": "Target",
		"description": "Description",
		"creationDate": "Creation Date",
		"lastUpdated": "Last Updated",
		"status": "Status",
		"statuses": {
			"failed": "FAILED",
			"success": "SUCCESS",
			"running": "RUNNING"
		},
		"unknownService": "Unknown Service",
		"unknownJobType": "Unknown Job Type",
		"footerMsg": "{{num1}} - {{num2}} of {{num3}} jobs",
		"placeholder": "No Jobs Found",
		"constants": {
			"jobType": {
				"dataProtection": "Data Protection",
				"advancedNetworking": "Advance Networking",
				"networking": "Networking",
				"directConnect": "Direct Connect",
				"compute": "Compute",
				"hybridDMZService": "Hybrid DMZ"
			},
			"workflowType": {
				"vmBackup": "VM Backup",
				"vmPolicy": "VM Policy",
				"vmRestore": "VM Restore",
				"resourcePoolPolicy": "Resource Pool Policy",
				"networkCreate": "Create Network",
				"networkUpdate": "Update Network",
				"networkDelete": "Delete Network",
				"gatewayCreate": "Create Router",
				"gatewayUpdate": "Update Router",
				"gatewayDelete": "Delete Router",
				"gatewayForcesync": "Force Sync Router",
				"gatewayRedeploy": "Redeploy Router"
			}
		}
	},
	"networks": {
		"landing": "Networks"
	},
	"networkDashboard": {
		"networking": "Networking",
		"networks": "NETWORKS",
		"gateways": "EDGE GATEWAYS",
		"directConnectNetworks": "DIRECT CONNECT NETWORKS",
		"publicIpEnabled": "Public IPs have been used",
		"directConnectIpEnabled": "Direct Connect IPs have been used",
		"ipUsed": "IPs Used",
		"ipFree": "IPs Free",
		"ipUsageRetrieveError": "Failed to retrieve IP usage for network ",
		"networkRetrieveError": "Failed to retrieve networks",
		"gatewayRetrieveError": "Failed to retrieve gateways",
		"directConnectRetrieveError": "Failed to retrieve Direct Connect Networks",
		"vdcNetworkRetrieveError": "Failed to retrieve Org Vdc Networks"
	},
	"directConnect": {
		"directConnect": "Direct Connect",
		"directConnects": "Direct Connects",
		"network": "Network",
		"networks": "Networks",
		"connectedGateways": "Connected Routers",
		"edit": "Edit",
		"disconnect": "Disconnect",
		"ipPool": "IP Pool",
		"gatewayIPPool": "Gateway IP Pool",
		"addNetwork": "ADD NETWORK",
		"connectGateway": "CONNECT GATEWAY",
		"add": "Add",
		"update": "Update",
		"disassociateGateway": {
			"title": "Disassociate Gateway from Direct Connect",
			"text": "Do you want to disassociate direct connect",
			"from": "from"
		},
		"wizard": {
			"connectGateway": "Connect Gateway",
			"selectGateway": "Select Gateway",
			"directConnectNetworks": "Direct Connect Networks",
			"configureGateway": "Configure Gateway",
			"manageUplinkNetworks": "Manage Uplink Networks",
			"selectGWSubTitle": "Select the Gateway to which you want to connect the Direct Connect",
			"vdc": "Virtual DataCenter",
			"selectVDC": "Select a VDC",
			"selectAGateway": "Select a Gateway",
			"org": "Organization",
			"manageUplinksSubTitle": "Review uplink networks attached to the gateway and associate/disassociate them if required",
			"dcNetworksSubTitle": "View/Configure Direct Connect Networks",
			"gatewayAddress": "Gateway Address",
			"IPPool": "IP Pool: (Enter an IP range or IP addresses)",
			"IPPoolView": "IP Pool",
			"networkPrefix": "Network Prefix",
			"configureGatewaySubTitle": "Configure IP Pools to be associated with the selected gateway",
			"gatewayIPPool": "Gateway IP Pool: (Enter an IP range or IP addresses)",
			"configureGatewayNote": "This IP pool is a subset of the direct connect network IP pool can be used to configure network services like NAT, IPSEC etc",
			"gatewayDetails": "Gateway Details",
			"gateway": "Gateway",
			"gatewayConfig": "Gateway Configuration",
			"IPRanges": "IP Ranges",
			"gatewayIP": "Gateway IP",
			"modifiedUplinks...": "Modified uplinks of the selected gateway",
			"disconnectPublicNetworkMsg": "Warning. You are trying to disconnect a public network. You have to contact the support team if you need to reconnect this network.",
			"noNWSelected": "Gateway needs to have at least one uplink"
		},
		"connectNetworkDialog": {
			"addTitle": "Add Gateway address and IP pool associated with the Direct Connect",
			"editTitle": "Edit IP pool associated with the Direct Connect",
			"gatewayAddress": "Gateway Address:",
			"networkPrefix": "Network Prefix:",
			"ipPool": "IP Pool:",
			"ipPoolMessage": "(Enter an IP range or IP addresses)",
			"buttonCancel": "Cancel",
			"buttonApply": "Apply",
			"prefixInvalidMessage": "Invalid Prefix Length",
			"addNetworkHeader": "Add Network for ",
			"editNetworkHeader": "Edit Network for "
		}
	},
	"gateway": {
		"gateways": "Gateways",
		"actions": "Actions",
		"createGateway": "Create Gateway",
		"editGateway": "Edit Gateway",
		"deleteGateway": "Delete Gateway",
		"on": "on",
		"more": "more",
		"gatewayIp": "Gateway IP",
		"configuration": "Configuration",
		"highAvailability": "High Availability",
		"status": "Status",
		"externalNetworks": "External Networks/ IP Allocations",
		"manageEdgeGateway": "Manage Edge Gateway Services",
		"name": "Name",
		"enterGatewayName": "Enter gateway name",
		"nameRequired": "Gateway Name is Required",
		"charLimitExceeded": "Gateway Name should not exceed 35 characters",
		"description": "Description",
		"enterDescription": "Enter description",
		"selectOrg": "Select Org",
		"selectVdc": "Select VDC",
		"selectExternalNetwork": "Select External Network",
		"ipCount": "IP Count",
		"enterIpCount": "Enter IP Count",
		"ipCountRequired": "No Of IPs requested must not be greater than free IPs available",
		"freeIps": "Free IPs",
		"cancel": "Cancel",
		"ok": "Ok",
		"deleteConfirm": "This will delete {{name}} Gateway. Click on OK to proceed.",
		"org": "Org",
		"vdc": "VDC",
		"externalNetwork": "External Network"
	},
	"hdmz": {
		"header": {
			"title": "VMware HCX",
			"vcloud": "VMware vCloud",
			"air": "Air",
			"services": "Services",
			"dashboard": "Dashboard",
			"inventory": "Inventory",
			"settings": "Settings",
			"about": "About",
			"help": "Help",
			"logout": "Log out"
		},
		"auth": {
			"rememberMe": "Remember Me",
			"login": " LOG IN",
			"invalidUsername": "Invalid username or password",
			"logoutProgress": "Logout in Progress",
			"logoutComplete": "You have successfully logged out of VMware HCX"
		},
		"title": "Data Center Designer",
		"viewTitle": "Build Hybrid DMZ",
		"hybridDMZLanding": {
			"setup": "Setup",
			"cancel": "Cancel",
			"reset": "Reset",
			"download": "Download",
			"downloadText": "Save the Network Graph as PNG file",
			"fullOrVisible": "Image Visibility",
			"fileName": "File Name",
			"fullScale": "Full Graph",
			"visible": "Current Viewport",
			"resetDrawing": "Reset Network Graph",
			"resetConfirmation": "Are you sure you want to reset the network diagram?",
			"setupHDMZPostRequestSuccessMessage": "HDMZ Setup request posted successfully. Refer Activity logs for further details.",
			"hdmzJobRunningMsg": "A network topology job is under progress...",
			"setupHDMZPostRequestWarningMessage": "There is already hybrid DMZ job is running in the system to configure the network topology. Do you want continue with another Hybrid DMZ job. This might overwrite the changes made in the previous network topologies.",
			"closeDesigner": "Exit Designer",
			"closeConfirm": "Are you sure you want to exit without saving your changes?",
			"exit": "Yes",
			"no": "No",
			"buildHybridDMZ": {
				"title": "BUILD HYBRID DMZ"
			},
			"editHybridDMZ": {
				"title": "MODIFY HYBRID DMZ"
			},
			"addTransitNetwork": {
				"title": "Add Network",
				"editTitle": " Edit Network",
				"name": "Name",
				"ipRange": "IP Ranges",
				"gateway": "Gateway Address",
				"prefix": "Prefix Length",
				"duplicateName": "Network with this name already exists"
			},
			"addEdge": {
				"title": "ADD ROUTER",
				"perimeterEdge": "Aggregation Router",
				"computeEdge": "Access Router",
				"edgeSize": "Appliance Size",
				"ha": "High Availability",
				"duplicateName": "Router with this name already exists",
				"perimeter": {
					"title": "Add Aggregation Router",
					"editTitle": " Edit Aggregation Router",
					"name": "Name",
					"deploymentContainer": "Deployment Container"
				},
				"compute": {
					"title": "Add Access Router",
					"editTitle": " Edit Access Router",
					"name": "Name",
					"deploymentContainer": "Deployment Container",
					"scope": "Scope"
				}
			},
			"addZone": {
				"title": "Add Zone",
				"editTitle": " Edit Zone",
				"name": "Name",
				"ipRange": "IP Ranges",
				"gateway": "Gateway Address",
				"prefix": "Prefix Length",
				"duplicateName": "Zone with this name already exists"
			},
			"connectNetwork": {
				"title": "Connect to Network: ",
				"network": "Network",
				"ip": "Primary IP Address",
				"secondaryIp": "Secondary IP Addresses",
				"secondaryIpPlaceholder": "Use comma (',') to separate IPs",
				"subnet": "Subnet Mask",
				"prefix": "Prefix Length",
				"prefixInvalidMessage": "Invalid Prefix Length",
				"interfaceType": "Interface Type",
				"uplink": "Uplink",
				"internal": "Internal",
				"rangeIpAddress": "IP Address should be within the following range(s) ",
				"noNewNetworkAvailable": "No new network available",
				"ipOutOfRangeError": "IP: {{invalidIp}} is not in range(s).",
				"ipDuplicateError": "Duplicate IP: {{invalidIp}}",
				"ipConflictError": "IP: {{invalidIp}} is already in use.",
				"isBgpReconfigRequired": "BGP Auto-Config",
				"bgpReconfigMsg": "Activating BGP Auto-config will pair all the routers in the same network segment. By default all the connected and static routes will be redistributed. Deactivating the BGP auto config will not configure the BGP routes on this router only."
			},
			"disconnectNetwork": {
				"title": "Disconnect Network",
				"text": "Are you sure you want to disconnect?",
				"confirm": "Disconnect",
				"isBgpReconfigRequired": "BGP Auto-Config",
				"bgpReconfigMsg": "Activating BGP Auto-config will pair all the routers in the same network segment. By default all the connected and static routes will be redistributed. Deactivating the BGP auto config will not configure the BGP routes on this router only."
			},
			"deleteNetwork": {
				"title": "Delete Network",
				"text": "Cannot delete the network. Please disconnect the router(s) connected to the network first.",
				"close": "Close"
			},
			"sddcPools": {
				"title": "Available SDDC Pools",
				"deploymentContainerName": "Deployment Container Name",
				"vCenterUrl": "vCenter URL",
				"resourcePoolName": "Resource Pool name"
			},
			"scopes": {
				"title": "Available vCenters",
				"scopeName": "Scope Name"
			},
			"systemNetworks": {
				"title": "Available Networks",
				"name": "Name",
				"description": "Description",
				"text": "Text"
			},
			"templates": {
				"title": "Import A Template",
				"selectATemplate": "Select A Template",
				"templateDetails": "Template Details",
				"customizations": "Advanced Customizations",
				"loading": "Loading...",
				"routers": "Routers: ",
				"networks": "Networks: ",
				"default": "DEFAULT"
			},
			"buttonSave": "SAVE",
			"errorMsg": "This field is mandatory",
			"ipFormatErrorMsg": "Invalid Format",
			"notConnectedGateways": "Gateway(s): {{gateways}} should be connected to atleast one network",
			"singleImproperGatewayConfig": "Gateway: {{improperGateway}} is not configured properly",
			"improperGatewayConfig": "Gateway(s): {{improperGateways}} are not configured properly",
			"noNewObjectsMsg": "There are no new objects added in the current network view, saving the other changes."
		},
		"graph": {
			"menu": {
				"connectNetwork": "Connect to Network",
				"removeGateway": "Remove Router",
				"manageGateway": "Configure Edge Services",
				"removeNetwork": "Remove Network",
				"editGateway": "Edit Router",
				"editNetwork": "Edit Network",
				"importTemplate": "Import a template"
			},
			"tips": {
				"connectedNetwork": "Connected Network",
				"connection": "Connection",
				"on": " on ",
				"ip": "IP Address: ",
				"int": "Interface: ",
				"prefix": "Subnet Prefix Length: ",
				"otherInterfaces": "Other Networks",
				"noOtherInterfaces": "No Other Networks",
				"unused": "Unused",
				"disconnect": "Disconnect",
				"edit": "Edit",
				"secondaryIps": "Secondary Addresses: ",
				"importATemplate": "Import a template"
			},
			"states": {
				"NOT_REALIZED": "Failed"
			}
		},
		"designerLanding": {
			"detailsPane": {
				"connectedNetworks": "Connected Networks",
				"addAConnection": "Add a Connection",
				"addConnectionDisableMessage": "All NICs are in use",
				"displayProperties": "Display Properties",
				"labelPosition": "Label Position",
				"color": "Color",
				"redirectToANS": "Manage with Advanced Gateway Services",
				"info": {
					"localNetworksHead": "Local Networks",
					"localNetworksForGatewayHead": "Local Networks for Gateway",
					"vnicColumn": "vNIC",
					"nameColumn": "Name",
					"primaryaddressColumn": "Primary Address"
				},
				"deleteNetworkErrorMessage": "Cannot delete the network. Please disconnect the router(s) connected to the network first.",
				"saveNetworkErrorMessage": "Gateway Address, Prefix and IP Range(s) are all mandatory if any one of them is provided",
				"noUnusedLocalNetworksErrorMessage": "No internal networks are available. Do you want to create a new internal network before connecting a router with this zone? ",
				"createNewLocalNetworkMessage": "Create internal network.",
				"connectedGateways": " Connected Gateways",
				"networkScope": "Network Scope",
				"incompleteConfiguration": "Incomplete Configuration",
				"gatewayInterfaceUsedUpWarningMessage": "All interfaces for this gateway are used. Please select another gateway to connect to this zone."
			},
			"dynamicForm": {
				"buttons": {
					"edit": "EDIT",
					"save": "SAVE",
					"cancel": "CANCEL",
					"delete": "DELETE"
				},
				"labels": {
					"name": "Name",
					"vCenter": "vCenter",
					"routerSize": "Router Size",
					"highAvailability": "High Availability",
					"deploymentContainer": "Deployment Container",
					"gatewayAddress": "Gateway Address",
					"prefixLength": "Prefix Length",
					"ipRanges": "IP Range(s)",
					"networkName": "Network Name",
					"primaryIpAddress": "Primary IP Address",
					"secondaryIpAddresses": "Secondary IP Addresses",
					"interfaceType": "Interface Type",
					"description": "Description",
					"tags": "Tags",
					"mappings": "Mappings",
					"gatewayName": "Gateway Name",
					"type": "Type"
				},
				"options": {
					"compact": "Compact (1 vCPU, 512 MB MEM)",
					"large": "Large (2 vCPU, 1024 MB MEM)",
					"quadlarge": "Quad-Large (4 vCPU, 2048 MB MEM)",
					"xlarge": "X-Large (6 vCPU, 8192 MB MEM)",
					"internal": "Internal",
					"uplink": "Uplink"
				},
				"signpostMessage": {
					"allowedIps": "IP Address should be within the following range(s): "
				},
				"alerts": {
					"invalidInput": "Invalid Input"
				},
				"zoneMappings": {
					"resourcePool": "Resource Pool",
					"folder": "Folder",
					"cluster": "Cluster",
					"loading": "Loading...",
					"mapAnEntityFrom": "Map an entity from"
				},
				"tooltips": {
					"edit": "Edit",
					"localNetworks": "Local Networks",
					"advancedGatewayServices": "Manage with Advanced Gateway Services",
					"applyZoneTemplates": "Apply Zone Templates"
				}
			},
			"topMenu": {
				"setup": "SETUP",
				"setupTip": "Setup your topology",
				"reset": "RESET",
				"resetTip": "Reset to the previous saved version",
				"preview": "PREVIEW",
				"rearrange": "REARRANGE",
				"rearrangeTip": "Auto align the objects in the topology diagram",
				"export": "EXPORT",
				"exportTip": "Export",
				"asJson": "as JSON",
				"asImage": "as an Image",
				"settings": "Settings",
				"settingsPane": {
					"objectDefaults": "Object Defaults",
					"layoutDefaults": "Layout Defaults",
					"aggrRouterPrefix": "Aggregation Router Name Prefix",
					"accRouterPrefix": "Access Router Name Prefix",
					"transitNetworkPrefix": "Transit Network Name Prefix",
					"zonePrefix": "Zone Name Prefix",
					"networkOrientation": "Transit Network Orientation",
					"nwOrientationVertical": "VERTICAL",
					"nwOrientationHorizontal": "HORIZONTAL",
					"objectGrabLabel": "Allow Object Grab",
					"grabOn": "ON",
					"grabOff": "OFF",
					"zoneEnableLabel": "Allow Zone Operations",
					"zoneEnabled": "ACTIVATE",
					"zoneAlreadyEnabled": "ACTIVATED",
					"zoneDisabled": "DEACTIVATED",
					"zoneOperationStatus": "Zone Operations Status"
				}
			},
			"sideMenu": {
				"msgAddComponent": "Click an object and drop into the design area",
				"addToolTip": "Add Router or Network",
				"networksHead": "Networks",
				"routersHead": "Routers",
				"deckAccessRouter": "Access",
				"deckAggregationRouter": "Aggregation",
				"deckTransitNetwork": "Transit",
				"deckInternet": "Internet",
				"deckDirectconnect": "Direct Connect",
				"deckInternalNetwork": "Internal",
				"addZoneToolTip": "Add Zone",
				"hdmzTemplateHead": "Hybrid DMZ Templates",
				"deckHdmzTemplateImport": "Run Analyzer for HDMZ Template Recommendation",
				"msgManageTemplates": "Click for importing templates",
				"tooltips": {
					"importExportTemplatesTooltip": "Import Hybrid-DMZ Templates"
				}
			},
			"export": {
				"title": "Export",
				"downloadText": "Save the Network Graph as PNG file",
				"fullOrVisible": "Image Visibility",
				"fileName": "File Name",
				"fullScale": "Full Graph",
				"visible": "Current Viewport"
			},
			"notEnoughPrivilegeMessage": "You do not have enough access privileges to use Data Center Designer"
		},
		"guidedTour": {
			"splash": {
				"head": "Welcome to Data Center Designer",
				"mesg": "Setup and manage your datacenter and networking with a visual representation. Learn how to create routers, networks and manage networking and services with our guided tour."
			},
			"overview": {
				"plus": {
					"head": "Add a Router or Network",
					"mesg": "Click the + button from the objects menu, then choose a datacenter object that you wish to add by clicking on the object, followed by clicking again within the highlighted area on the designer to place the object. If you wish to discard the selected object, click outside the highlighted area."
				},
				"zones": {
					"head": "Add a Compute Zone",
					"mesg": "Click this button and then click again on a vCenter to create a zone. A zone logically groups compute elements, e.g. hosts, so they could all be subjected to the same set of services or networking rules."
				},
				"templates": {
					"head": "Import a template",
					"mesg": "A Template helps you build a topology quickly within your datacenter. Run Template-Recommendation analyzer to help pick a template that best suites your objectives. The networks and routers as per the template definition will be linked and placed within the defined containers. Once a template is imported, the changes are applied only when you click 'Setup'"
				},
				"setup": {
					"head": "Setup your datacenter topology",
					"mesg": "Clicking setup button will submit all your unsaved changes to the server and deploy your topology."
				},
				"reset": {
					"head": "Reset unsaved changes",
					"mesg": "Clicking reset button will clear all your unsaved changes and reset the topology diagram to the last saved state. The last saved state would be the state when you clicked Setup last time."
				},
				"rearrange": {
					"head": "Rearrange items",
					"mesg": "The system will make best-fit effort to rearrange the items. The changes will not be saved or deployed until you click Setup."
				},
				"export": {
					"head": "Export the diagram or view as Image",
					"mesg": "You may wish to take a print of the current view or the entire diagram on a paper. This button saves the diagram or the view as a file of your choice, in your local filesystem, which you may wish to print later."
				},
				"settings": {
					"head": "Settings for customizing your view",
					"mesg": "You may wish to adjust some of the viewing aspects, based on your taste or ease. This settings is your personal adjustment, and does not impact the underlying state or views of others who might be viewing the same diagram on another browser."
				},
				"help": {
					"head": "Help Topics",
					"mesg": "The Help presents you with more such guided tours."
				}
			}
		},
		"templates": {
			"splash": {
				"startIdMsg": "Use our Intelligent Datacenter Builder to choose the right hybrid topology template for your HCX cloud.",
				"startIdBtn": "START WITH ID BUILDER",
				"startEditorMsg": "Use our editor to drag and drop datacenter objects and build you hybrid topology from scratch.",
				"startEditorBtn": "START WITH EDITOR",
				"startGTMsg": "Learn how to create zones, routers, networks and manage networking and services with our guided tour.",
				"startGTBtn": "TAKE A GUIDED TOUR"
			},
			"heading": {
				"recommendation": {
					"mesg": "We recommend using the following template: "
				},
				"others": {
					"mesg": "Suggested Templates"
				}
			},
			"selected": {
				"button": {
					"previewAndImport": "Preview and Import",
					"answerAgain": "Answer Questions Again"
				}
			},
			"card": {
				"button": {
					"view": "View",
					"import": "Import",
					"back": "Back",
					"continue": "Continue",
					"finish": "Finish",
					"cancel": "Cancel"
				}
			},
			"mapper": {
				"tooltips": {
					"notAuthorized": "Not authorized for roles: {{roles}}",
					"selectAnExisting": "Click to select an existing {{item}} to map.",
					"createAnItem": "Click to create a {{item}}.",
					"addOrImport": "Click to add or import a System-Owned network, e.g. Direct Connects, Internet, ...",
					"noItems": "No {{item}} exists that matches the criteria. Create / Import a new {{item}}."
				},
				"createOrUseExisting": "Create or Use existing",
				"importOrUseExisting": "Import or Use existing",
				"invalidTemplate": "Invalid Template! Cancel this import by clicking the [X] button.",
				"linkRouter": "Link Router"
			}
		}
	},
	"serviceUnavailable": "Service Not Available",
	"unauthorizedMessage": "You are not authorized to use this service",
	"routes": {
		"title": "Router",
		"addRouter": "Add new Router",
		"add": "Add",
		"editRouter": "Edit Router",
		"edit": "Edit",
		"delRouter": "Delete Router",
		"del": "Delete",
		"showFailures": "Show Failure(s)",
		"ok": "OK",
		"cancel": "Cancel",
		"failed": "Failed",
		"serviceDisruption": "This operation may result in temporary service disruption. Click OK to continue.",
		"redeploy": "Redeploy",
		"forceSync": "Force Sync",
		"actions": "Actions",
		"delConfirmation": "This will delete '{{name}}' router. Click DELETE to continue.",
		"importGateway": "Import Gateway",
		"vc": "vCenter",
		"selectVc": "Select vCenter",
		"gateway": "Gateway",
		"selectGateway": "Select Gateway",
		"importRouter": "Import NSX edge in NLS"
	},
	"network": {
		"title": "Network"
	},
	"vcNetwork": {
		"name": "Name",
		"description": "Description",
		"type": "Type",
		"vcenters": "vCenter(s)",
		"internet": "Internet",
		"directConnect": "Direct Connect",
		"associateText": "Associate vCenter(s) and dvPortGroup(s) of the selected vCenter(s)",
		"ipScopes": "IP Scopes",
		"cancel": "CANCEL",
		"emptyText": "This field cannot be empty!",
		"add": "ADD",
		"edit": "EDIT",
		"delete": "DELETE",
		"importNW": "Import Network",
		"editNW": "Edit Network",
		"vC": "vCenter",
		"backing": "Backing",
		"associate": "Associate",
		"select": "Select",
		"virtualWire": "Virtual Wire",
		"selectBackings": "Select Backings",
		"dvpg": "dvPortGroup",
		"distributedSwitch": "Distributed Switch",
		"ok": "Ok",
		"showFailures": "Show Failure(s)",
		"import": "Import",
		"addNetwork": "Add Network",
		"editNetwork": "Edit Network",
		"deleteNetwork": "Delete Network",
		"importNetwork": "Import Network",
		"thisWillDelete": "This will delete",
		"clickDELToCont": "Click DELETE to continue",
		"failed": "failed",
		"editImport": "Edit Import",
		"actions": "Actions",
		"deleteBackings": "Delete Backings",
		"addIPScope": "Add IP Scope",
		"editIPScope": "Edit IP Scope",
		"deleteIPScope": "Delete IP Scope",
		"enterNetworkName": "Enter network name",
		"enterNetworkDescription": "Enter network description",
		"network": "network",
		"trunk": "Trunk",
		"backingInfoText": "Incase of multiple vCenters environment while importing networks in secondary vCenter’s, select one or more backing port/s belonging to a vCenter where Global Deployment Container is present.",
		"primaryVC": "indicates primary vC",
		"deleteNetworkRequesting": "Requesting network delete..."
	},
	"vcAdministration": {
		"systemUpdates": "System Updates",
		"troubleshooting": "Troubleshooting",
		"deploymentContainers": "Deployment Containers",
		"deploymentContainer": "Deployment Container",
		"diceIntegration": "DICE",
		"diceConfigurationHeader": "DICE Configuration",
		"diceUploadHeader": "Upload data to DICE",
		"diceUploadInfo": "Upload VCenter Inventory to DICE for analysis.",
		"diceApiKey": "API Key",
		"diceApiSecret": "API Secret",
		"diceCustomerId": "Customer ID",
		"diceModelId": "Model ID",
		"diceCollectionId": "Collection ID",
		"diceApiKeyLabel": "Please provide API Key.",
		"diceApiSecretLabel": "Please provide API Secret.",
		"diceApiCustomerIdLabel": "Please provide Customer ID.",
		"diceApiModelIdLabel": "Please provide Model Id.",
		"diceApiCollectionIdLabel": "Please provide Collection Id",
		"diceUploadSuccessful": "Last upload successful",
		"diceUploadUnsuccessful": "Last upload unsuccessful",
		"loading": "Loading...",
		"reset": "Reset",
		"add": "Add",
		"edit": "Edit",
		"delete": "Delete",
		"vCScope": "vCenter Scope",
		"resourcePool": "Resource Pool",
		"storage": "Storage",
		"folder": "Folder",
		"name": "Name",
		"datastore": "Datastore",
		"vc": "vCenter",
		"enterDC": "Enter Deployment Container Name",
		"selectVc": "Select vCenter",
		"selectRP": "Select a Resource Pool",
		"selectDS": "Select a Datastore",
		"selectFolder": "Select a Folder",
		"selectGW": "Select a Gateway",
		"global": "Global",
		"select": "Select",
		"selectOne": "Select a",
		"ok": "Ok",
		"cancel": "Cancel",
		"deleteConfirm": "Are you sure you want to delete deployment container",
		"noDCFound": "No Deployment Containers are found",
		"hmzConfig": "Hybrid DMZ Configuration",
		"configHDMZ": "Configure Hybrid DMZ",
		"replicationMode": "Replication Mode",
		"multicastResources": "Multicast Resources",
		"vniResources": "VNI Resources",
		"unicast": "Unicast",
		"multicast": "Multicast",
		"save": "Save",
		"networkIPRanges": "Network IP Ranges",
		"ipRangesError": "Invalid IP Ranges",
		"emptyField": "This field cannot be empty!",
		"multicastAddresses": "Multicast Addresses",
		"segmentIDPool": "Segment ID pool",
		"segmentRange": "In the range of 5000 - 16777215. Multiple ranges are separated by comma",
		"multicastRange": "Recommended range 224.0.0.0 - 239.255.255.255. Multiple ranges are separated by comma",
		"logicalNetworkConfig": "Logical Network Configuration",
		"nsxControlPlaneMode": "NSX Control plane mode",
		"addDeploymentContainer": "Add Deployment Container",
		"isGlobal": "Is Global",
		"auditLogs": "Audit Logs",
		"activityLogs": "Activity Logs",
		"alerts": "Alerts",
		"interConnectConfiguration": "Interconnect Configuration (Deprecated)",
		"create": "Create",
		"selectDVPG": "Select dvPortGroup",
		"dvpg": "dvPortGroup",
		"gatewayAddress": "Gateway Address",
		"startAddress": "Start Address",
		"endAddress": "End Address",
		"doYouWantToDelete": "Do you want to delete",
		"enterName": "Enter Name",
		"addNetwork": "Add Network",
		"addNetworkProfile": "Create Network Profile",
		"ipRanges": "IP Ranges",
		"gateway": "Default Gateway IP Address",
		"networkPrefix": "Prefix Length",
		"createFleetConfig": "+ Create",
		"network": "Network",
		"selectNetwork": "Select Network",
		"deleteConfigConfirm": "This will delete the interconnect configuration. Click DELETE to continue.",
		"vCenter": "vCenter",
		"networkTypes": "Network Types"
	},
	"interface": {
		"vnic": "VNIC",
		"connectedTo": "Connected To",
		"select": "Select",
		"name": "Name",
		"nameInterface": "Please enter name of the interface",
		"ipAddresses": "IP Addresses",
		"add": "Add",
		"edit": "Edit",
		"remove": "Remove",
		"ok": "OK",
		"connectRouterNetwork": "Connect Router to a Network",
		"configureIPAddresses": "Configure IP Addresses",
		"networkIPRanges": "Network IP Ranges for",
		"primaryAddress": "Primary Address",
		"providePrimaryAddress": "Please provide primary address",
		"secondaryAddresses": "Secondary Addresses",
		"prefixLength": "Prefix Length",
		"providePrefixLength": "Please provide prefix length between 1 and 32",
		"cancel": "Cancel",
		"save": "Save",
		"connectivityStatus": "Connectivity Status",
		"type": "Type",
		"subInterface": "Sub Interface",
		"tunnelId": "Tunnel Id",
		"tunnelIdRange": "Value between 1 and 4093",
		"parentInterfaceIndex": "Parent Interface Index",
		"parentInterface": "Parent Interface",
		"trunkInterface": "Trunk interface",
		"mtu": "MTU",
		"validMtuMsg": "Please provide value between 68 and 9000"
	},
	"guidedTour": {
		"hcx": {
			"welcome": {
				"head": "&nbsp;   Welcome to VMware HCX!   &nbsp;",
				"mesg": "Design and deploy your cloud network topology. Configure replication-based protection for Virtual Machines in the cloud. Access diagnostic views and system logs."
			}
		},
		"dashboard": {
			"splash": {
				"head": "Dashboard",
				"mesg": "The Dashboard view summarizes components, resources and tracks user-driven activities. You will learn about what is found throughout the dashboard in this guided tour."
			},
			"overview": {
				"vcenters": {
					"head": "VCENTERS",
					"mesg": "Total number of local vCenters registered with the HCX system."
				},
				"virtualMachines": {
					"head": "VIRTUAL MACHINES",
					"mesg": "The total number of Virtual Machines found in the cloud, including powered off systems."
				},
				"edgeGateways": {
					"head": "EDGE GATEWAYS",
					"mesg": "The total number of NSX Edge Services Gateways deployed in this cloud."
				},
				"networks": {
					"head": "NETWORKS",
					"mesg": "The total number of networks segments created in this cloud.  Local, transit and public networks are counted and included."
				},
				"directConnects": {
					"head": "DIRECT CONNECT NETWORKS",
					"mesg": "The total number of Direct Connect or private WAN network lines configured on this cloud."
				},
				"resourceUsage": {
					"head": "Resource Usage",
					"mesg": "Resource Usage is an Administrator-only view showing consumed/available values for the various resource types."
				},
				"miniActivityLogs": {
					"head": "Activity Logs",
					"mesg": "This section of the dashboard provides a preview of the most recent user-driven activities, along with a success/failure status.  A link is provided for viewing a more complete view of the activity logs."
				},
				"vcdOrganization": {
					"head": "vCloud Organization",
					"mesg": "The organization name of in the vCloud Director."
				},
				"vcdOrgVdcs": {
					"head": "vCloud Organization VDCs",
					"mesg": "The number of Virtual Datacenters in the vCloud Directors."
				}
			}
		},
		"services": {
			"splash": {
				"head": "Welcome to the Hybrid Cloud Services",
				"mesg": "Take a tour of the hybrid cloud services and offerings in VMware HCX."
			},
			"overview": {
				"computes": {
					"head": "COMPUTE",
					"mesg": "View and manage all your compute instances. You will be redirected to the corresponding vCenter instance."
				},
				"vcNetworking": {
					"head": "NETWORKING",
					"mesg": "Allows you to Edit, Delete, Import or Create new Routers and Networks in your Cloud. The 'Network' tab allows you to manage existing or create new Local or Transit networks. A Local network is scoped within a vCenter instance, while a Transit network can span across multiple vCenter instances. The 'Router' tab allows you to create and manage 'Access' or 'Aggregation' level routers."
				},
				"vcdNetworks": {
					"head": "NETWORKS",
					"mesg": "Allows you to manage Networks and Edge-Gateways in this Organization."
				},
				"dataProtection": {
					"head": "DATA PROTECTION",
					"mesg": "Allows you to create and manage Backups of mission critical Virtual Machines in your cloud."
				},
				"disasterRecovery": {
					"head": "DISASTER RECOVERY",
					"mesg": "Allows you to create and manage Disaster Recovery for your cloud."
				}
			}
		}
	},
	"support": {
		"title": "Support",
		"supportInfo": "Support Information",
		"description": "When contacting support, please have the following information available :",
		"buildVersion": "Build version",
		"systemID": "System ID",
		"systemType": "System type",
		"troubleShootingLink": "Troubleshooting",
		"friendlySystemName": "System name",
		"linkLastCommunicated": "Link last communicated",
		"systemTypeNsp": "VMware HCX - cloud",
		"systemTypeHcm": "VMware HCX - Connector",
		"copyToClipboard": "Copy information to clipboard"
	},
	"interconnectConfiguration": {
		"introduction": {
			"preRequisite": "An Interconnect Configuration is a prerequisite for adding an HCX Interconnect between two sites.",
			"noExistingCP": "You have no interconnect configuration created ",
			"whatIsCP": "What is an Interconnect Configuration?",
			"descriptionPara1": "This configuration is required for HCX Interconnect deployment which activates Mobility, Network Extension and other hybrid services. In this workflow, you will provide IP pools, networks and compute parameters to describe where the HCX Interconnect virtual appliances will be deployed and connected.",
			"descriptionPara2": "In this step, only the Interconnect configuration profile is created - actual virtual appliance deployment will occur when deployment workflow is run from VMware HCX"
		},
		"createFleetConfiguration": "create interconnect configuration",
		"createFleetConfigurationBtn": "Create",
		"transformFleetConfigLabel": "Activate Multi-Site Service Mesh",
		"syncServiceMesh": "Sync Multi-Site Service Mesh",
		"transformFleetConfigTitle": "Activate Multi-Site Service Mesh",
		"syncServiceMeshTitle": "Sync Multi-Site Service Mesh",
		"wizardSelectResources": "Select Compute Resources",
		"wizardProvideNetworkProfile": "Configure Network profile(s)",
		"wizardReadyToComplete": "Ready To Complete",
		"wizardToolTipName": "Please provide a name for the Interconnect Configuration",
		"networkProfile": "Network Profile",
		"selectNetworkType": "Select Network Type",
		"dvprotgroup": "Distributed Port Group",
		"logicalSwitch": "NSX Logical Switch",
		"type": "Type",
		"lanFacingNetwork": "LAN facing networks",
		"wanFacingNetwork": "WAN facing networks",
		"vMotion": "vMotion",
		"managment": "Management",
		"internet": "Internet",
		"dc1": "Direct Connect Network 1",
		"dc2": "Direct Connect Network 2",
		"networkProfiles": "Network profile(s)",
		"advancedOption": "Advanced Option",
		"selectIPAMProvider": "Select IPAM Provider",
		"HCX": "HCX",
		"NSX": "NSX",
		"selectNSXPool": "Select NSX IP Pool",
		"network": "Network",
		"ipamProvider": "IPAM Provider",
		"nsxIPPool": "NSX IP Pool",
		"addStaticRoutes": "Add Static routes",
		"staticRoute": "Static Route",
		"staticRoutes": "Static Routes",
		"nextHop": "Next Hop",
		"mtu": "MTU",
		"stanadardPortGroup": "Standard Switch Network",
		"staticRoutesIntro": "Optional Static Route entries can be useful for reaching networks via a network path alternate to the configured default gateway.  The Next Hop IP Address must belong to a directly connected network.",
		"selectVCenter": "Select a vCenter",
		"selectNetwork": "Select a Network",
		"enable": "Activate",
		"sync": "Sync",
		"cancel": "Cancel",
		"transformFleetConfirmationMessage": "This will transform the current interconnect configuration to Service Mesh Configuration. After this transformation, the configuration will be shared between Interconnect and Service Mesh and both will continue to work. Click OK to proceed.",
		"syncServiceMeshConfirmationMessage": "Interconnect configuration is already transformed to Multi-Site Service Mesh Configuration. This will sync Multi-Site Service Mesh with changes done in Interconnect configuration to keep both of them in sync."
	},
	"hybridInterconnect": {
		"titile": "Hybrid Interconnect",
		"computeProfile": "Compute Profiles",
		"sitePairing": "Site Pairing",
		"interconnectMesh": "Service Mesh",
		"networkProfile": "Network Profiles",
		"sentinelManagement": "Sentinel Management"
	},
	"troubleShooting": {
		"applianceLogNotEligibleTooltip": "The appliance is not ready for log collection"
	},
	"alerts": {
		"title": "Alerts",
		"errMsg": "Unable to fetch alerts at this moment.",
		"instanceId": "InstanceID",
		"alertDescription": "Alert Description",
		"viewAll": "View All",
		"noAlerts": "No Alerts",
		"loading": "Loading...",
		"status": "Severity",
		"entityName": "Component",
		"creationDate": "Creation Date",
		"suppress": "Suppress",
		"acknowledge": "Acknowledge",
		"resetToGreen": "Reset to Green",
		"acknowledged": "Acknowledged",
		"entityType": "Component Type",
		"message": "Message",
		"acknowledgedBy": "Acknowledged By",
		"at": "at",
		"info": "Info",
		"warning": "Warning",
		"critical": "Critical",
		"infoAlerts": "Show Informational",
		"alertCardVcErrorMessage": "Alerts Card : Unable to fetch VC-HCM details!"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/app/en.json
// module id = tWh6
// module chunks = 0